export default __webpack_public_path__ + "static/media/jungleGym.c44cf858.jpg";